export default __webpack_public_path__ + "static/title-0f8e49b37cde38f3affa2005d0a9268e.svg";